import styled from "@emotion/styled"
import PopperContainer from "../../components/Radiate/PopperContainer/PopperContainer"
import Toggle from "../../components/Radiate/Toggle/Toggle"

export const StyledPopperContainer = styled(PopperContainer)`
  >.popper-dropdown {
    margin: 8px;
  }
`


export const ColorDisplayBorder = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 21px;
  border: 2px solid #ffffff;
  border-color: ${(props) => (props.selected ? props.color : "#ffffff")};
  background-color: #ffffff;
  margin: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => props.readOnly ? "inherit" : "pointer"};
  
`

export const ColorDisplay = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 14px;
  background-color: ${(props) => props.color};
  background-image: url(${(props) => props.image});
  background-size: cover;
`

export const Label = styled.div`
  padding-bottom: ${(props) => props.noPadding ? "0px" : "8px"};
  font-size: ${(props) => props.theme.textSm};

  .text {
    color: ${(props) => props.theme.gray6};
  }
`

export const ColorPicker = styled.div`
   display: flex;
    align-items: center;
    box-sizing: border-box;

    .pic-preview {
      width: 72px;
      height: 72px;
      border-radius: 36px;
      overflow: hidden;
      background: #eee;
      margin-right: 16px;
      flex-shrink: 1;
      object-fit: cover;
    }

    .url-container {
      display: flex;
      border: 1px solid ${(props) => props.theme.gray1};
      border-radius: 4px;
      font-size: ${(props) => props.theme.textSm};
      word-break: break-all;
       color: ${(props) => props.theme.gray7};

      >.url-wrapper {
        font-weight: bold;
        border-right: 1px solid ${(props) => props.theme.gray1};
        padding: 16px;
       
        .url {
          cursor: pointer;

          &:hover {
            color: ${(props) => props.theme.themeColorLight};
          }
        }
      }

      >.button-wrapper {
        display: flex;
        align-items: center;
      }
    }
`
export const SToggle = styled(Toggle)`
  margin-left: 8px;
`